import { mapState } from 'vuex'

export { expandEventMixin }

const expandEventMixin = {
  data() {
    return {
      expanded: true
    }
  },
  computed: {
    ...mapState('udlIndex', ['eventHub'])
  },
  methods: {
    expand(flag) {
      this.expanded = flag
    }
  },
  created() {
    this.eventHub.$on('expand', this.expand)
  },
  beforeDestroy() {
    this.eventHub.$off('expand', this.expand)
  }
}
